import {NamaIconProps, StringOrUndefined} from "@/utils/presenters/interfaces.ts";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import ClientCache from "@/utils/login/ClientCache.ts";

export default class NamaIconUtils {
  private static icons: Record<string, any>;
  private static colors: Record<string, any>

  static toIconCode(props: NamaIconProps): string {
    if (!this.icons)
      this.fetchIcons();
    let ic = this.searchForIconOrColor(props, 'iconCode', this.icons);
    if (ic)
      return ic;
    if (!props.defaultIcon && props.allowedValue && props.enumTypeName && ["EntityTypeDF", "DocumentEntityTypeDF", "MasterEntityTypeDF"].includes(props.enumTypeName)) {
      return "nm-monitoring";
    }
    return props.defaultIcon || '';
  }

  static fetchColors() {
    this.colors = ClientCache.getCustomGUISettings()?.tooltipsAndReportsAndRevise?.customizedFieldsInfo?.colors;
  }

  static fetchIcons() {
    this.icons = ClientCache.getCustomGUISettings()?.tooltipsAndReportsAndRevise?.customizedFieldsInfo?.icons;
  }

  static toColorCode(props?: NamaIconProps): string {
    if (!this.colors)
      this.fetchColors();
    if (!props)
      return;
    const themeColor = this.searchForIconOrColor(props, 'colorCode', this.colors);
    if (!themeColor)
      return props.defaultColor;
    else if (ObjectChecker.isString(themeColor))
      return themeColor; //light & dark
    if (useNamaFlagsStore().darkMode)
      return themeColor.darkColor || props.defaultColor;
    else
      return themeColor.lightColor || props.defaultColor;
  }

  static searchForIconOrColor(props: NamaIconProps, key: string, map?: Record<string, any>): string {
    if (props.block) {
      if (props.block[key])
        return props.block[key];
      let ic = this.searchForIcon(props.presenter?.entityType, props.block.id, map)
      if (ic)
        return ic;
      ic = this.searchForIcon(props.presenter?.entityType, props.block.title?.resourceId, map)
      if (ic)
        return ic;
    }
    if (props.enumTypeName || props.allowedValue) {
      let ic = this.searchForIcon(props.enumTypeName, props.allowedValue, map)
      if (ic)
        return ic;
    }
    if (props.menuItem) {
      if (props.menuItem[key])
        return props.menuItem[key];
      let ic = this.searchForIcon(undefined, props.menuItem.titleId, map);
      if (ic)
        return ic;
      ic = this.searchForIcon(undefined, props.menuItem.code, map);
      if (ic)
        return ic;
      ic = this.searchForIcon(undefined, props.menuItem.target?.targetEntity, map);
      if (ic)
        return ic;
      ic = this.searchForIcon(undefined, props.menuItem.target?.targetRecord?.entityType, map);
      if (ic)
        return ic;
    }
    if (props.constant) {
      let ic = this.searchForIcon(undefined, props.constant, map);
      if (ic)
        return ic;
    }
    if (props.timeline) {
      if (props.timeline[key])
        return props.timeline[key]
      let ic = this.searchForIcon(undefined, props.timeline.actionType, map)
      if (ic)
        return ic;
    }
    return '';
  }

  private static searchForIcon(prefix: StringOrUndefined, idOrResource: StringOrUndefined, icons?: Record<any, any>): StringOrUndefined {
    if (!idOrResource)
      return;
    if (!icons)
      return;
    let ic: StringOrUndefined;
    if (prefix) {
      ic = icons[prefix + "." + idOrResource];
      if (ic)
        return ic;
    }
    return icons[idOrResource]
  }
}
